import styled from 'styled-components'

export const ShowFrequencyButton = styled.button`
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    bottom: 25px;
    left: calc(50% + 134px);
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme['gray-400']};
    transform: translateX(-50%);
    background: ${({ theme }) => theme['gray-100']};
    padding: 16px;
    gap: 8px;
    overflow: hidden;

    i {
        color: ${({ theme }) => theme['blue-700']};
    }
`
